import { combineReducers } from 'redux';
import { ExpenseSheetActions, removeExpenseEntry, updateExpenseEntry } from 'store/entities/timesheet/actions/expenseActions';
import { removeTimeEntry, TimeSheetActions, updateTimeEntry } from 'store/entities/timesheet/actions/timeActions';
import { isLoadingReducer, singleValueReducer } from 'store/reducerUtils';
import { setEditEntryId } from 'modules/timeAndExpense/components/EditEntry/store/actions';
import { extendReducer } from 'store/utils/reducers/extendReducer';

const editEntryId = singleValueReducer<string | null>(setEditEntryId.action, null);
const isEntryUpdating = (state = false, action: ExpenseSheetActions | TimeSheetActions): boolean => {
    switch (action.type) {
        case updateExpenseEntry.initType:
        case updateTimeEntry.initType:
            return true;
        case updateExpenseEntry.successType:
        case updateTimeEntry.successType:
        case updateExpenseEntry.errorType:
        case updateTimeEntry.errorType:
            return false;
        default:
            return state;
    }
};
const isEntryRemoving = extendReducer(
    isLoadingReducer(removeTimeEntry),
    isLoadingReducer(removeExpenseEntry),
);

export const editEntry = combineReducers({
    editEntryId,
    isEntryUpdating,
    isEntryRemoving,
});
